// src/components/DashboardSuggesties.js
//
// Suggestieblok bovenaan het dashboard. Nieuwe gebruikers krijgen een startpunt
// ("Begin hier"), terugkerende gebruikers het doorloopje waar ze gebleven waren plus
// aanbevelingen. De backend kiest de doorloopjes met dezelfde logica als de
// herinneringsmail: GET /api/dashboard/suggesties.
import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { trackEvent } from '../utils/track';
import './DashboardSuggesties.css';

const STRAPI_URL = process.env.REACT_APP_STRAPI_URL;

const Skelet = () => (
  <div className="widget-card dashboard-suggesties skeleton-loading">
    <div className="skeleton-line" style={{ width: '45%', height: '1.4rem' }}></div>
    <div className="skeleton-line" style={{ width: '70%', height: '0.9rem', marginBottom: '1rem' }}></div>
    {[0, 1, 2].map((i) => (
      <div key={i} className="suggestie-skelet-regel">
        <div className="skeleton-line suggestie-skelet-icoon"></div>
        <div className="skeleton-line" style={{ width: '60%', height: '1rem' }}></div>
      </div>
    ))}
  </div>
);

export default function DashboardSuggesties() {
  const location = useLocation();
  const [keuze, setKeuze] = useState(null);
  const [laden, setLaden] = useState(true);

  useEffect(() => {
    let actief = true;
    let jwt = null;
    try {
      jwt = localStorage.getItem('jwt');
    } catch {
      // storage geblokkeerd: blok niet tonen
    }
    if (!jwt) {
      setLaden(false);
      return undefined;
    }
    fetch(`${STRAPI_URL}/api/dashboard/suggesties`, { headers: { Authorization: `Bearer ${jwt}` } })
      .then((res) => (res.ok ? res.json() : Promise.reject(new Error(`status ${res.status}`))))
      .then((data) => {
        if (actief) setKeuze(data);
      })
      .catch(() => {
        if (actief) setKeuze(null);
      })
      .finally(() => {
        if (actief) setLaden(false);
      });
    return () => {
      actief = false;
    };
  }, []);

  // Navigeren wacht niet op het event; trackEvent faalt zelf stil.
  const meldKlik = (slug, positie) => {
    trackEvent({
      type: 'suggestie_klik',
      path: location.pathname,
      payload: { variant: keuze?.variant, slug, positie },
    });
  };

  if (laden) return <Skelet />;
  if (!keuze) return null;

  const aanbevolen = keuze.aanbevolen || [];
  const verder = keuze.verder || null;
  if (!verder && aanbevolen.length === 0) return null;

  const isStart = keuze.variant === 'start';
  // Zonder doorloopje om verder te gaan blijft alleen de rij aanbevelingen over.
  const kop = isStart ? 'Begin hier' : verder ? 'Verder waar je was' : 'Ook interessant';

  const Regel = ({ doorloopje, positie }) => (
    <Link
      to={`/doorloopjes/${doorloopje.slug}`}
      className="widget-item-card"
      onClick={() => meldKlik(doorloopje.slug, positie)}
    >
      {doorloopje.afbeelding ? (
        <img src={doorloopje.afbeelding} alt="" className="widget-item-icon" loading="lazy" />
      ) : (
        <div className="widget-item-icon placeholder"></div>
      )}
      <div className="widget-item-text">
        <h4>{doorloopje.titel}</h4>
      </div>
    </Link>
  );

  return (
    <div className="widget-card dashboard-suggesties">
      <div className="widget-header">
        <h3>{kop}</h3>
      </div>

      {isStart && <p className="suggestie-intro">Drie doorloopjes om mee te starten.</p>}

      {!isStart && verder && (
        <Link
          to={`/doorloopjes/${verder.slug}`}
          className="suggestie-verder"
          onClick={() => meldKlik(verder.slug, 'verder')}
        >
          {/* Zonder afbeelding de kaart zonder afbeelding, niet met een leeg vlak. */}
          {verder.afbeelding && (
            <img src={verder.afbeelding} alt="" className="suggestie-verder__afbeelding" loading="lazy" />
          )}
          <div className="suggestie-verder__tekst">
            <h4>{verder.titel}</h4>
            <span className="suggestie-verder__knop">Verder</span>
          </div>
        </Link>
      )}

      {!isStart && verder && aanbevolen.length > 0 && <p className="suggestie-kopje">Ook interessant</p>}

      {aanbevolen.map((d, i) => (
        <Regel key={d.slug} doorloopje={d} positie={i + 1} />
      ))}
    </div>
  );
}
